import { render, staticRenderFns } from "./AreaStep.vue?vue&type=template&id=08d1a494"
import script from "./AreaStep.vue?vue&type=script&lang=js"
export * from "./AreaStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports